import { ProgressBar } from "@/components/WeeklyRewards/ProgressBar/ProgressBar";
import { SignInBadge } from "@/components/core/sidemenu/AvatarBadge";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { usePassportProvider } from "@/context";
import { useLoginModal } from "@/context/LoginModalContext";
import { useRightNav } from "@/context/RightNavContext";
import { useOnboardingModal } from "@/hooks/useOnboardingModal";
import { usePathname } from "next/navigation";

export function AppHeader({ signInCallback }: { signInCallback: () => void }) {
  const { isLoggedIn, userInfo } = usePassportProvider();
  const { openLoginModal } = useLoginModal();
  const { isOnboardingModalEnabled } = useOnboardingModal();
  const { isCollapsed, toggleCollapse } = useRightNav();
  const pathname = usePathname();
  const suppressSignInBadge = pathname?.includes("/games/fates-exp");

  return (
    <div className="sticky top-0 z-10 p-4 w-full flex items-center justify-between gap-2">
      <div className="flex-1 flex justify-center max-w-[900px] mx-auto">
        <ProgressBar />
      </div>

      <div className="flex items-center gap-2">
        {isCollapsed && (
          <div className="md:hidden">
            {isLoggedIn ? (
              <Button
                variant="ghost"
                size="icon"
                onClick={toggleCollapse}
                title="Open profile"
                className="relative"
              >
                <Avatar className="w-8 h-8 border border-white/30 shadow-lg">
                  <AvatarImage
                    src="/images/profile/spaceman.png"
                    alt={userInfo?.nickname || "User"}
                    className="object-cover"
                  />
                  <AvatarFallback className="bg-white/20 backdrop-blur-md text-white font-semibold border border-white/30 text-xs">
                    {(userInfo?.nickname || userInfo?.email || "U")
                      .slice(0, 2)
                      .toUpperCase()}
                  </AvatarFallback>
                </Avatar>
              </Button>
            ) : (
              !suppressSignInBadge && (
                <div className="cursor-pointer">
                  <SignInBadge
                    onClick={
                      isOnboardingModalEnabled ? signInCallback : openLoginModal
                    }
                  />
                </div>
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
}
